import React, { lazy, Suspense } from 'react';
import { Route, IndexRoute } from 'react-router';
import Default from './containers/defaultContainer';
//import Login from './containers/loginContainer';
//import Loader from './components/subcomponents/loader';

const OverView = lazy(() => import('./containers/overviewContainer'));
const AccessDenied = lazy(() => import('./containers/accessDeniedContainer'));
const MobileDevice = lazy(() => import('./containers/mobileDeviceContainer'));
const BankAccount = lazy(() => import('./containers/bankAccountContainer'));
const Orders = lazy(() => import('./containers/ordersContainer'));
const AwardDetails = lazy(() => import('./containers/awardDetailsContainer'));
const OrderDetails = lazy(() => import('./containers/orderDetailsContainer'));
const PageNotFound = lazy(() => import('./containers/pageNotFoundContainer'));


function WaitingComponent(Component) {
  return props => (
    <Suspense fallback={<div className='suspenseLoader'>Loading...</div>}>
      <Component {...props} />
    </Suspense>
  );
}

const routes = (basePath) => (
  <Route path="/" component={Default}>
    <IndexRoute component={WaitingComponent(OverView)} />
    <Route path={`${basePath}/accessDenied`} component={WaitingComponent(AccessDenied)} />
    <Route path={`${basePath}/pairingcodes`} component={WaitingComponent(MobileDevice)} />
    {/* <Route path={`${basePath}/login`} component={Login} /> */}
    <Route path={`${basePath}/overview`} component={WaitingComponent(OverView)} />
    <Route path={`${basePath}/bankaccounts`} component={WaitingComponent(BankAccount)} />
    <Route path={`${basePath}/orders`} component={WaitingComponent(Orders)} />
    {/* <Route path={`${basePath}/awarddetails/:orderId/:sapOrderId`} component={AwardDetails} /> */}
    <Route path={`${basePath}/awarddetails/:orderId`} component={WaitingComponent(AwardDetails)} />
    <Route path={`${basePath}/orderdetails/:orderId`} component={WaitingComponent(OrderDetails)} />
    <Route path={`${basePath}/*`} component={WaitingComponent(PageNotFound)} />
  </Route>
);

export default routes;
